class ScrollWatcher {
  constructor () {
    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateBodyClass = this.updateBodyClass.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.initialise()
  }

  initialise () {
    this.updateBodyClass()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.updateBodyClass()
  }

  updateBodyClass () {
    this.isTicking = false

    document.body.classList.toggle(
      this.scrolledClass,
      this.lastKnownY > this.threshold,
    )
  }

  get threshold () {
    return 0
  }

  get scrolledClass () {
    return `lyt-Theme-scrolled`
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new
  new ScrollWatcher()
})
